import React, { Component } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import "./Boilerplate.css";
import "./Datepicker.css";
import "./LoginScreen.css";
import "./App.css";

import WebPages from "./WebPages";
import Logout from "./logout";
import Data from "./data";
import Settings from "./settings";
import AddUser from "./AddUser";
import ScrollToTop from "./ScrollToTop";
import TokenChecker from "./TokenChecker";
import Message from "./Message";
import Header from "./Header";

import { store } from "./config/config";

class App extends Component {
  constructor() {
    super();
    this.state = {
      cookiesAllowed: false,
    };
  }

  setCookieState = (allowed) => {
    this.setState({ cookiesAllowed: allowed });
  };

  render() {
    return (
      <Provider store={store}>
        <Router>
          <ScrollToTop>
            <TokenChecker />
            <Message />
            <Header />
            <Routes>
              <Route path="/data" element={<Data />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/addUser" element={<AddUser />} />
              <Route path="/logout" element={<Logout />} />
              <Route path="*" element={<WebPages />} />
            </Routes>
          </ScrollToTop>
        </Router>
      </Provider>
    );
  }
}

export default App;